<template>
    <div>
        <slide-up-modal
            v-if="updateModalDisplayed"
            ref="documentUpdateModal"
            modal-id="documentUpdateModal"
            :modal-title="updateModalData.title"
            @modal-closed="hideUpdateModal"
        >
            <p class="text-danger">
                Êtes-vous certain de vouloir {{ updateModalData.verb }} le document #{{ selectedDocument.model.inpi_id }} ?
            </p>

            <p>
                {{ updateModalData.message }}
            </p>

            <div class="actions" style="margin-top: 20px;">
                <button class="btn btn-complete btn-sm" @click="performDocumentUpdate">Valider</button>
                <button class="btn btn-default btn-sm" @click="hideUpdateModal">Annuler</button>
            </div>
        </slide-up-modal>

        <h3>Documents INPI à contrôler</h3>

        <div v-if="declarationId && !componentIsLoading">
            <table class="table table-striped" v-if="documents.length > 0">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Reçu le</th>
                        <th></th>
                    </tr>
                </thead>

                <tbody>
                    <tr v-for="document in documents" :key="document.id">
                        <td>
                            {{ document.inpi_id }}
                        </td>

                        <td>
                            {{ document.created_at | moment-date }}
                        </td>

                        <td style="text-align: right;">
                            <a 
                                :href="getStreamUrl(document.id)" 
                                class="btn btn-complete btn-sm" 
                                target="_blank"
                                :disabled="anyFormDisplayed">
                                Visualiser
                            </a>

                            <button 
                                class="btn btn-default btn-sm"
                                :disabled="invalidCustomer || anyFormDisplayed"
                                @click="displayUpdateModal(document, 'validate')"
                            >
                                Valider
                            </button>

                            <button 
                                class="btn btn-default btn-sm"
                                :disabled="invalidCustomer || anyFormDisplayed"
                                @click="displayUpdateModal(document, 'refuse')"
                            >
                                Refuser
                            </button>
                        </td>
                    </tr>
                </tbody>
            </table>

            <div class="alert alert-info" v-else>
                <i class="fa fa-info-circle"></i> Aucun document à contrôler
            </div>
        </div>

        <component-loader v-else></component-loader>
    </div>
</template>

<script type="text/babel">
    import {mapState, mapActions} from "vuex"
    import ComponentLoader from 'components/ComponentLoader'
    import SlideUpModal from 'components/Modals/SlideUpModal'
    import cookies from "cookiesjs"
    
    export default {
        name: 'InpiRbeDocuments',

        props: {
            declarationId: {
                type: Number,
                default: null,
            }
        },

        components: {
            ComponentLoader,
            SlideUpModal
        },

        data() {
            return {
                componentIsLoading: false,
                anyFormDisplayed: false,
                selectedDocument: null,
            }
        },

        created() {
            if (this.declarationId) {
                this.fetchDocuments()
            }
        },

        methods: {
            ...mapActions('beneficialOwners', ['fetchInpiDocuments', 'updateInpiDocument']),

            fetchDocuments() {
                this.componentIsLoading = true

                this.fetchInpiDocuments(this.declarationId)
                    .then(() => this.componentIsLoading = false)
            },

            getStreamUrl(documentId) {
                return __API_URL__ + '/inpi_rbe_documents/' + documentId + '/stream?token=' + cookies('token')
            },

            displayUpdateModal(document, action) {
                const selectedDocument = {
                    model: document,
                    action: action
                }

                this.selectedDocument = selectedDocument
            },

            hideUpdateModal() {
                this.selectedDocument = null
            },

            performDocumentUpdate()
            {
                if (this.documentForUpdate) {
                    this.updateModal.isLoading = true
    
                    this.updateInpiDocument(this.documentForUpdate)
                        .then(() => {
                            this.selectedDocument = null

                            this.$emit('inpi-document-updated')
                        })
                        .catch(() => {})
                        .then(() => this.updateModal.isLoading = false)
                }
            }
        },

        computed: {
            ...mapState(['customer']),
            ...mapState('beneficialOwners', {
                'stateFormDisplayed': 'formDisplayed',
                'documents': 'inpiDocuments'
            }),

            invalidCustomer() {
                return !this.customer || !this.customer.hasOwnProperty('profile')
                    || !this.customer.profile.hasOwnProperty('erp_id')
                    || !this.customer.profile.erp_id
            },

            availableActions() {
                return ['validate', 'refuse']
            },

            updateModal() {
                return this.$refs.documentUpdateModal
            },

            updateModalData() {
                let data = null

                if (this.selectedDocument && -1 !== this.availableActions.indexOf(this.selectedDocument.action)) {
                    if ('validate' == this.selectedDocument.action) {
                        data = {
                            title: 'Validation de document',
                            verb: 'valider',
                            message: "N'oubliez pas de vérifier les informations des bénéficiaires effectifs par la suite"
                        }
                    } else {
                        data = {
                            title: 'Refus de document',
                            verb: 'refuser',
                            message: "N'oubliez pas de vérifier les informations des bénéficiaires effectifs"
                        }
                    }
                }

                return data
            },

            updateModalDisplayed() {
                return this.updateModalData
            },

            documentForUpdate() {
                let document = null

                if (this.selectedDocument && -1 !== this.availableActions.indexOf(this.selectedDocument.action)) {
                    document = _.clone(this.selectedDocument.model)

                    document.status = 'validate' == this.selectedDocument.action ? 'validated' : 'refused'
                }

                return document
            }
        },

        watch: {
            declarationId(newValue, oldValue) {
                if (newValue && newValue != oldValue) {
                    this.fetchDocuments()
                }
            },

            stateFormDisplayed(newValue, oldValue) {
                this.anyFormDisplayed = newValue
            }
        }
    }
</script>

<style lang="scss" scoped>
    td, th {
        vertical-align: middle!important;
    }

    .alert-info {
        background-color: #d9edf7;
        border-color: #d9edf7;
        color: #31708f;
    }
</style>



// WEBPACK FOOTER //
// client/components/BeneficialOwners/InpiRbeDocuments.vue